var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlancJls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 525.89 279.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-6);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-width: .75px;\n      }\n\n      .cls-2, .cls-7 {\n        stroke: #e63d11;\n      }\n\n      .cls-8, .cls-7 {\n        fill: #e63d11;\n      }\n\n      .cls-3 {\n        stroke-width: 7px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke: #fff;\n      }\n\n      .cls-9 {\n        fill: #1a171b;\n      }\n\n      .cls-4, .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-7 {\n        stroke-width: .5px;\n      }\n\n      .cls-6 {\n        stroke: #e30613;\n        stroke-width: 2.49px;\n      }\n\n      .cls-11 {\n        fill: #e30613;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    x: 382.15,
    y: 155.96,
    width: 152.64,
    height: 136.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.67,
    dy: 5.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "384.03 158.06 384.03 170.41 384.43 170.41 403.78 170.41 403.8 152.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61,35.18c1.54-1.87,3.56-4.02,6.16-6.16,2.32-1.91,4.56-3.36,6.51-4.45h23.71c.9.59,2.21,1.5,3.68,2.74,6.19,5.22,9.14,11.13,11.13,15.24,5.63,11.6,8.44,17.4,10.62,22.26,2.28,5.11,5.67,12.48,10.1,21.38l21.4-52.89c.41-1.19,1.63-4.24,4.79-6.51,2.06-1.47,4.09-2.01,5.29-2.23h23.54c1.89.41,5.74,1.55,8.49,4.97,3.42,4.25,3.06,9.47,2.74,14.04-.19,2.69-.82,6.93-3.07,11.8l-41.1,72.78v53.76h-35.91c-.79-.27-1.96-.76-3.13-1.71-2.96-2.4-3.69-5.89-4.11-7.88-.25-1.18-.5-2.95-.34-5.14v-38.69L61,35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M229.98,73.93c6.33,0,11.47,5.14,11.47,11.47s-5.14,11.47-11.47,11.47-11.47-5.14-11.47-11.47,5.14-11.47,11.47-11.47ZM220.09,105.56h19.77v64.06h-19.77v-64.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M316.61,160.65c-.23-.43-.44-.87-.63-1.32M317.34,161.89c-.26-.4-.5-.82-.73-1.24M357.81,163.09v-1.4h-.26c-.2.32-.41.63-.63.92M315.97,159.33c-.99-2.28-1.53-4.88-1.53-7.79,0-22.14,26.89-22.54,43.36-22.54,0-6.99-5.8-11.47-12.65-11.47-6.46,0-11.86,2.9-16.08,7.64l-10.54-10.81c7.25-6.85,17.79-10.28,28.21-10.28,23.07,0,29.26,11.73,29.26,33.08v21.79M352.93,141.65c-6.06,0-19.51.53-19.51,9.23,0,4.75,5.01,6.99,9.36,6.99,7.78,0,15.03-4.09,15.03-12v-4.22h-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.63,70.51h19.77v99.65h-19.77v-99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M384.03,157.02v-50.87h19.77v10.28h.26c4.22-7.78,9.75-11.86,18.45-11.86,2.24,0,4.75.13,6.59.66v18.06c-2.77-.79-5.54-1.32-8.44-1.32-15.03,0-16.87,8.7-16.87,21.49v9.09"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 444.73,
    cy: 116.67,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.79,159.68v-20.67c0-7.38-.13-16.87-10.28-16.87s-11.86,8.04-11.86,16.34v31.9h-19.77v-64.06h18.98v8.7h.26c2.64-5.01,9.1-10.28,18.72-10.28,20.03,0,23.72,13.18,23.72,30.32v24.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "289.77 159.99 289.77 170.38 309.56 170.38 309.56 159.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "356.92 164.14 356.92 170.41 375.99 170.41 375.99 160.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "189.77 182.41 243.2 182.41 290.22 162.66 351.72 162.66 407.27 148.69 438.05 123.82"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M411.58,190.78c-8.03-1.88-15.81-7.1-19.97-14.23-.15,7.47,1.27,15.87,4.7,22.51,1.74,3.37,3.48,7.57,7.13,10.1-1.03,5.5-2.08,15.44,1.69,26.5,6.59,19.35,24.82,32.99,44.57,36,1.72.26,31.91,4.33,51.43-18.86,2.26-2.68,16.72-20.46,12-44.57-5.21-26.62-29.2-37.49-31.71-38.57-23.63-10.21-48.48-.28-61.85,11.94-3.65,3.34-6.24,6.65-7.98,9.19Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M485.84,232.96c.52-1,.98-2.03,1.39-3.09h-4.23s2.84,3.09,2.84,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M485.63,233.36c-.29.53-.59,1.06-.91,1.57l-4.64-5.05h2.34s3.21,3.48,3.21,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M484.47,235.31c-.41.64-.85,1.26-1.3,1.86l-6.72-7.28h3.07s4.95,5.42,4.95,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M482.9,237.53c-.44.56-.9,1.11-1.38,1.63l-8.57-9.26h2.9s7.05,7.63,7.05,7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M481.22,239.5c-.45.48-.91.94-1.38,1.39l-10.17-10.98h2.71s8.85,9.59,8.85,9.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M479.47,241.22c-.48.44-.97.86-1.48,1.26l-11.65-12.56h2.73s10.4,11.3,10.4,11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M465.75,229.91h-2.76s12.99,14.04,12.99,14.04c.56-.37,1.1-.76,1.62-1.17l-11.85-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M434.72,202.96c.38-.57.77-1.13,1.18-1.67l6.7,7.25h-2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M433.54,204.91c.3-.53.61-1.06.93-1.57l4.78,5.19h-2.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M436.57,208.54h-4.73c.43-1.11.93-2.19,1.48-3.23l3.24,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M443.2,208.54h2.81s-8.5-9.19-8.5-9.19c-.47.51-.91,1.04-1.34,1.59l7.03,7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M446.63,208.54h2.7s-10.1-10.93-10.1-10.93c-.48.45-.95.92-1.4,1.41l8.8,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M439.59,197.28c.48-.43.97-.85,1.47-1.25l11.57,12.51h-2.7s-10.35-11.26-10.35-11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M453.24,208.54h2.89s-12.96-14.05-12.96-14.05c-.59.39-1.17.8-1.73,1.24l11.8,12.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 459.54,
    cy: 219.26,
    r: 33.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 459.54,
    cy: 219.26,
    r: 36.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M443.47,194.29c4.62-2.98,10.13-4.7,16.04-4.7,12.61,0,23.38,7.86,27.67,18.95h-30.44M477.32,204.29l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5ZM472.41,204.29l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5ZM467.5,204.29l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5ZM462.59,204.29l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M475.51,244.25c-4.62,2.96-10.11,4.68-16,4.68-12.61,0-23.38-7.86-27.68-18.95l30.5-.06M456.37,235.51l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5ZM451.47,235.51l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5ZM446.56,235.51l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5ZM441.65,235.51l.76.5-.24-.88.71-.57-.91-.05-.32-.85-.32.85-.91.05.71.57-.24.88.76-.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M449.84,211.3h2.86v6.14c0,2.89-1.35,4.26-4.14,4.26-.59,0-1.44-.08-2.05-.27l.32-2.27c.38.11.88.2,1.38.2,1.02,0,1.62-.45,1.62-1.94v-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M455.39,218.66c.68.33,1.77.71,2.94.71.95,0,1.44-.3,1.44-.82,0-.44-.47-.73-1.71-1.08-1.74-.48-3.18-1.38-3.18-3.15s1.67-3.21,4.32-3.21c1.39,0,2.33.24,3.12.58l-.65,2.24c-.48-.2-1.35-.53-2.51-.53-.85,0-1.33.27-1.33.71,0,.55.65.73,1.98,1.15,1.98.64,2.92,1.59,2.92,3.14,0,1.71-1.35,3.29-4.61,3.29-1.35,0-2.67-.36-3.32-.7l.59-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M464.81,211.3h2.86v7.82h4.41v2.39h-7.27v-10.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M447.22,223.71h-1.51v-.49h3.62v.49h-1.52v3.89h-.59v-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M449.62,226.15c.01.71.54,1.06,1.19,1.06.47,0,.75-.08.99-.18l.11.42c-.21.09-.58.22-1.17.22-1.04,0-1.68-.65-1.68-1.59s.6-1.71,1.62-1.71c1.15,0,1.42.97,1.42,1.51,0,.12,0,.21-.02.26h-2.45ZM451.52,225.73c0-.27-.12-.93-.89-.93-.67,0-.94.54-1,.93h1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M455.34,227.47c-.16.08-.54.2-1.03.2-1.03,0-1.71-.67-1.71-1.61,0-.99.73-1.69,1.84-1.69.39,0,.74.1.91.19l-.14.45c-.16-.09-.41-.17-.77-.17-.79,0-1.24.52-1.24,1.18,0,.73.53,1.18,1.21,1.18.38,0,.63-.1.81-.17l.11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M456.09,222.95h.59v2.05h.01c.1-.18.26-.34.46-.45.18-.11.41-.17.64-.17.43,0,1.21.24,1.21,1.42v1.8h-.59v-1.73c0-.55-.23-1-.83-1-.42,0-.74.29-.86.59-.04.08-.04.17-.04.28v1.85h-.59v-4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M460.01,225.32c0-.31,0-.6-.03-.86h.53l.03.56h.02c.16-.31.56-.64,1.14-.64.43,0,1.22.24,1.22,1.42v1.79h-.59v-1.74c0-.55-.23-1-.82-1-.43,0-.75.3-.87.61-.03.07-.04.17-.04.26v1.86h-.59v-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M464.61,223.55c0,.19-.14.37-.38.37-.22,0-.36-.17-.36-.37s.15-.37.38-.37.37.17.37.37ZM463.94,227.6v-3.14h.59v3.14h-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M468.04,227.47c-.16.08-.54.2-1.03.2-1.03,0-1.71-.67-1.71-1.61,0-.99.73-1.69,1.84-1.69.39,0,.74.1.91.19l-.14.45c-.16-.09-.41-.17-.77-.17-.79,0-1.24.52-1.24,1.18,0,.73.53,1.18,1.21,1.18.38,0,.63-.1.81-.17l.11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M470.69,227.6l-.06-.42h-.02c-.18.25-.56.5-1.07.5-.71,0-1.03-.48-1.03-.9,0-.75.69-1.19,2.07-1.18v-.06c0-.2-.06-.73-.79-.73-.33,0-.67.1-.92.26l-.14-.39c.3-.19.71-.3,1.14-.3,1.07,0,1.29.74,1.29,1.34v1.11c0,.28.01.54.05.76h-.54ZM470.6,226c-.74-.02-1.48.11-1.48.7,0,.36.26.54.58.54.48,0,.76-.29.87-.54.02-.06.03-.13.03-.18v-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M472.18,222.95h.59v4.65h-.59v-4.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlancJls);
export default __webpack_public_path__ + "static/media/Blanc-JLS.cd9a3f0c4338eb43347160512ed7b2e0.svg";
export { ForwardRef as ReactComponent };